import {Directive, forwardRef, HostBinding, Input} from '@angular/core';
import { DraggableDirective } from './draggable.directive';
import {SlickColumnEx} from "../../stocks/models/slick-column-ex";

@Directive({
    selector: '[appSortable]',
    providers: [
        { provide: DraggableDirective, useExisting: forwardRef(() => SortableDirective) }
    ]
})
export class SortableDirective extends DraggableDirective {
    @HostBinding('class.sortable') sortable = true;
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/sortable.directive.ts